import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { SimCardResponse, SimCardCreateRequest, SimCardUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { EnumToComboValues, GridColumnHelper } from '../utils';
import { SimCardDetailsSectionHandler } from './details.section';
import { CustomFieldsSectionHandler } from '../shared/info.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';

@RegisterEntityHandler('simcard')
@Injectable()
export class SimCardHandler extends EntityHandler<SimCardResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    states = ['inactive', 'active', 'suspended', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listSimCards/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listSimCards(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'simcard',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.SIMCARDS'),
        }));
    }

    getEntity(id: string): Promise<SimCardResponse> {
        return this.admin.getCached(`getSimCard/${id}`, api => api.entities.getSimCard(id), 10);
    }

    createEntity(ownerId: string, entity: SimCardCreateRequest): Promise<SimCardResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createSimCard(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateSimCard(entity.id, { state: state as any }));
    }   

    getGridColumns(ownerId: string): Promise<IKuiTableCol[]> {

        return this.admin.getCached(`getClient/${ownerId}`, api => api.accounts.getClient(ownerId), 60).then(client => {

            const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.SIMCARD.COLUMNS');

            const columns: IKuiTableCol[] = [
                grid.IconTextColumn('name', 'SERIAL_NUMBER', ICONS.simcard),
                grid.TextColumn('networkName', 'NETWORK', 120),
                grid.TextColumn('number', 'NUMBER', 150),
                grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
                grid.TextColumn('description', 'DESCRIPTION'),
                grid.IdNameTextColumn('device', 'DEVICE', 120),
            ];

            (client.customFields['simcard'] || []).forEach(customField => {
                columns.push({
                    ...grid.TextColumn(`fields.${customField.id}`, customField.title, 100),
                    format: (_col, row) => {
                        return row.fields && row.fields[customField.id];
                    },
                });
            });

            columns.push(grid.TimeAgoColumn('modifiedDate', 'MODIFIED'));
            return columns;
        });

    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<SimCardResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new SimCardDetailsSectionHandler(this.admin, ownerId),
                new CustomFieldsSectionHandler<SimCardResponse>(this.admin, ownerId, 'simcard'),
            ],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: SimCardUpdateRequest, sections: FormSectionHandler<SimCardResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'simcard',
            entity: {}, // set up some defaults if you want
            sections: [
                new SimCardDetailsSectionHandler(this.admin, ownerId),
                new CustomFieldsSectionHandler<SimCardResponse>(this.admin, ownerId, 'simcard'),
            ],
        });
    }

}













